'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    navDrawerBodyClassNames: function() {
        return navDrawerBodyClassNames;
    },
    useNavDrawerBodyStyles_unstable: function() {
        return useNavDrawerBodyStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reactdrawer = require("@fluentui/react-drawer");
const navDrawerBodyClassNames = {
    root: 'fui-NavDrawerBody'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: [
            "fif7vu7",
            "f1htewbf"
        ],
        Bt984gj: "f3gca8",
        mc9l5x: "f22iagw",
        Beiy3e4: "f1vx9l62",
        Belr9w4: "f1j0q4x9"
    }
}, {
    d: [
        [
            ".fif7vu7{padding:0 var(--spacingHorizontalXS) 0 var(--spacingHorizontalMNudge);}",
            {
                p: -1
            }
        ],
        [
            ".f1htewbf{padding:0 var(--spacingHorizontalMNudge) 0 var(--spacingHorizontalXS);}",
            {
                p: -1
            }
        ],
        ".f3gca8{align-items:unset;}",
        ".f22iagw{display:flex;}",
        ".f1vx9l62{flex-direction:column;}",
        ".f1j0q4x9{row-gap:var(--spacingVerticalXXS);}"
    ]
});
const useNavDrawerBodyStyles_unstable = (state)=>{
    'use no memo';
    (0, _reactdrawer.useDrawerBodyStyles_unstable)(state);
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(navDrawerBodyClassNames.root, styles.root, state.root.className);
    return state;
};
